import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth, roleHome } from '@/context/AuthContext'
import LogoLoader from '@/components/ui/LogoLoader'

export default function RequireAuth({ role }: { role?: 'customer' | 'staff' | 'admin' | 'partner' | 'sales' }) {
  const { user, loading } = useAuth()
  const location = useLocation()

  if (loading) {
    // Customer routes sit inside StorefrontLayout; the consoles wrap their
    // layout in this guard, so their loader stands alone on the blue body.
    if (role === 'customer') return <LogoLoader />
    return (
      <div className="flex min-h-screen items-center justify-center">
        <LogoLoader tone="dark" />
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname + location.search }} replace />
  }

  if (role && user.role !== role) {
    return <Navigate to={roleHome(user)} replace />
  }

  return <Outlet />
}
